"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolveAttributeFilterSubtitle = void 0;
// (C) 2022 GoodData Corporation
var react_intl_1 = require("react-intl");
var utils_1 = require("../utils");
/**
 * @internal
 */
function useResolveAttributeFilterSubtitle(isCommittedSelectionInverted, committedSelectionElements) {
    var intl = react_intl_1.useIntl();
    var isCommittedSelectionEmpty = committedSelectionElements.length === 0;
    var isNone = isCommittedSelectionEmpty && !isCommittedSelectionInverted;
    var isNegativeSelection = !isCommittedSelectionEmpty && isCommittedSelectionInverted;
    var isPositiveSelection = !isCommittedSelectionEmpty && !isCommittedSelectionInverted;
    var subtitle = intl.formatMessage({ id: "gs.list.all" });
    if (isNegativeSelection) {
        subtitle = intl.formatMessage({ id: "gs.list.all" }) + " " + intl.formatMessage({
            id: "gs.list.except",
        }) + " " + utils_1.getElementTitles(committedSelectionElements, intl);
    }
    else if (isPositiveSelection) {
        subtitle = utils_1.getElementTitles(committedSelectionElements, intl);
    }
    else if (isNone) {
        subtitle = intl.formatMessage({ id: "gs.filterLabel.none" });
    }
    return subtitle;
}
exports.useResolveAttributeFilterSubtitle = useResolveAttributeFilterSubtitle;
//# sourceMappingURL=useResolveAttributeFilterSubtitle.js.map